import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Grid, Card, CardContent, Typography, Box } from '@mui/material'
import { WhiteTextTypography, HighlightedTypography } from './Typography'

const IconBox = styled(Box)`
  margin-top: 32px;

  svg {
    width: 4em;
    height: 4em;
  }
`

const AttentionCard = ({ Icon, title, textArray, id }) => (
  <Grid container direction="column" pb={4} component={Card} sx={{ textAlign: 'center', flex: '1' }}>
    <IconBox>
      <Icon />
    </IconBox>

    <Grid container component={CardContent} direction="column" alignItems="center" style={{ paddingBottom: 0 }}>
      <Grid item>
        <HighlightedTypography color="primary" gutterBottom variant="h4">
          {title}
        </HighlightedTypography>
      </Grid>

      <Grid item>
        {textArray.map(text => (
          <Typography key={`text-array-${id}-${text.replace(' ', '_')}`} variant="body1" color="text.secondary">
            {textArray.length > 1 ? '- ' : ''}
            {text}
          </Typography>
        ))}
      </Grid>
    </Grid>
  </Grid>
)

AttentionCard.propTypes = {
  title: PropTypes.string.isRequired,
  textArray: PropTypes.arrayOf(PropTypes.string).isRequired,
  Icon: PropTypes.elementType.isRequired,
  id: PropTypes.string.isRequired,
}

const CardAttentionGrabSection = ({ title, cards }) => (
  <Grid container direction="column" mt={8}>
    <Grid item>
      <WhiteTextTypography gutterBottom variant="h4">
        {title}
      </WhiteTextTypography>
    </Grid>

    <Grid container justifyContent="center" alignItems="stretch">
      {cards.map(card => (
        <Grid
          item
          m={1}
          xs={12}
          md={3}
          sx={{ display: 'flex' }}
          key={`card-${card.title.replace(' ', '-').toLowerCase()}`}
        >
          <AttentionCard Icon={card.Icon} title={card.title} textArray={card.textArray} id={card.id} />
        </Grid>
      ))}
    </Grid>
  </Grid>
)

CardAttentionGrabSection.propTypes = {
  title: PropTypes.string.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(AttentionCard.propTypes)).isRequired,
}

export default CardAttentionGrabSection
